
      <!-- Take Action Section -->
      <section class="take-action-section">
        <h2 class="section-title">Take Action</h2>
        <p class="section-description">Skill-building and career resources for you</p>

        <!-- Resource Tabs -->
        <div class="resource-tabs">
          <button 
            class="tab" 
            [class.active]="activeTab === 'all'"
            (click)="setActiveTab('all')">
            All
          </button>
          <button 
            class="tab" 
            [class.active]="activeTab === 'career-support'"
            (click)="setActiveTab('career-support')">
            Career Support
          </button>
          <button 
            class="tab" 
            [class.active]="activeTab === 'skill-builder'"
            (click)="setActiveTab('skill-builder')">
            Skill Builder
          </button>
          <button 
            class="tab" 
            [class.active]="activeTab === 'academic-support'"
            (click)="setActiveTab('academic-support')">
            Academic Support
          </button>
        </div>

        <!-- Opportunity Cards Grid -->
        <div class="opportunity-grid">
          <app-opportunity-card
            *ngFor="let opportunity of filteredOpportunities"
            [opportunity]="opportunity">
          </app-opportunity-card>
        </div>
      </section>